<template>
  <div v-html="content_section">
      <!-- footer class="footer_area p_120">
        <div class="container">
            <div class="row footer_inner">
                <div class="col-lg-4">
                    <aside class="f_widget ab_widget">
                        <div class="f_title">
                            <h3>Dlealp</h3></div>
                        <p>Apreciamos a sua visita e com satisfação aguardaremos o seu retorno!</p>
                        <p> <strong> <i class="fa fa-phone"></i> Telefones: </strong>
                            <br/> (61) 3375.4222 ou (61) 3374.2101
                            <br/><strong> <i class="fa fa-mail-forward"></i> Email: </strong>
                            <br/> contato@dlealp.com.br
                            <br/><strong> <i class="fa fa-clock-o"></i> Horários: </strong>
                            <br/> De segunda a sexta das 08h às 18h
                            <br/>
                        </p>
                    </aside>
                </div>
                <div class="col-lg-4">
                    <aside class="f_widget news_widget">
                        <div class="f_title">
                            <h3>Projetos</h3></div>
                        <p>
                            <ul>
                                <li><a href="/galeria/Hopitalar">Hospitalar</a></li>
                                <li><a href="/galeria/Hotelaria">Hotelaria</a></li>
                                <li><a href="/galeria/Comerciais e Governamentais">Governo e comércio</a></li>
                                <li><a href="/galeria/Divisórias">Divisórias</a></li>
                                <li><a href="/galeria/Interiores">Interiores</a></li>
                                <li><a href="/galeria/Portas">Portas</a></li>
                            </ul>
                        </p>
                    </aside>
                </div>
                <div class="col-lg-4">
                    <aside class="f_widget social_widget">
                        <div class="f_title">
                            <h3>Estamos nas redes sociais</h3></div>
                        <p>Nos siga</p>
                        <ul class="list">
                            <li><a href=""><i class="fab fa-facebook"></i></i></a></li>
                            <li><a href="https://www.instagram.com/dlealpinteriores"><i class="fab fa-instagram"></i></i></a></li>
                        </ul>
                    </aside>
                </div>
            </div>
        </div>
    </footer -->
  </div>
</template>

<script>
export default {
    name: 'Footer',
    props: {
      content_section: String,
    },
}
</script>

<style>

</style>